import { defineStore } from "pinia";

export type PaymentMethod = "bean" | "fruit";

interface PaymentDialogState {
  visible: boolean;
  insufficientMethod: PaymentMethod;
  switchToMethod: PaymentMethod;
  applyGlobally: boolean;
}

interface PaymentStoreState {
  currentMethod: PaymentMethod;
  dialog: PaymentDialogState;
  confirmHandler: ((method: PaymentMethod) => void | Promise<void>) | null;
}

const buildDialogState = (method: PaymentMethod): PaymentDialogState => ({
  visible: true,
  insufficientMethod: method,
  switchToMethod: method === "bean" ? "fruit" : "bean",
  applyGlobally: false,
});

const usePaymentStore = defineStore("paymentStore", {
  state: (): PaymentStoreState => ({
    currentMethod: "bean",
    dialog: {
      visible: false,
      insufficientMethod: "bean",
      switchToMethod: "fruit",
      applyGlobally: false,
    },
    confirmHandler: null,
  }),
  actions: {
    setPaymentMethod(method: PaymentMethod) {
      this.currentMethod = method;
    },
    setApplyGlobally(value: boolean) {
      this.dialog.applyGlobally = value;
    },
    openInsufficientDialog(
      method: PaymentMethod,
      confirmHandler?: (method: PaymentMethod) => void | Promise<void>
    ) {
      this.dialog = buildDialogState(method);
      this.confirmHandler = confirmHandler || null;
    },
    closeDialog() {
      this.dialog.visible = false;
    },
    clearPendingAction() {
      this.confirmHandler = null;
    },
    cancelDialog() {
      this.closeDialog();
      this.clearPendingAction();
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: "paymentStore",
        storage: localStorage,
        paths: ["currentMethod"],
      },
    ],
  },
});

export default usePaymentStore;
